export const START_UI_GUIDE_EVENT = "smarttt:start-ui-guide";
export const CLOSE_AI_COACH_EVENT = "smarttt:close-ai-coach";
export const UI_TOUR_SETTLED_EVENT = "smarttt:ui-tour-settled";
export const OPEN_PLAYER_NEW_SESSION_EVENT = "smarttt:open-player-new-session";
export const OPEN_PRESENCE_REPORT_EVENT = "smarttt:open-presence-report";
export const OPEN_ADMIN_SIDEBAR_EVENT = "smarttt:open-admin-sidebar";
/** Set before navigating to Dashboard so SideBar can open once it mounts. */
export const PENDING_OPEN_ADMIN_SIDEBAR_KEY = "smarttt-pending-open-admin-sidebar";
export const OPEN_PROFILE_SMART_EVENT = "smarttt:open-profile-smart";

/** Open the admin left menu now, or after the next Dashboard SideBar mount. */
export function requestOpenAdminSidebar({ deferIfUnmounted = false } = {}) {
  if (typeof window === "undefined") return;
  if (deferIfUnmounted) {
    try {
      sessionStorage.setItem(PENDING_OPEN_ADMIN_SIDEBAR_KEY, "1");
    } catch {
      /* ignore */
    }
  }
  window.dispatchEvent(
    new CustomEvent(OPEN_ADMIN_SIDEBAR_EVENT, { detail: { open: true } })
  );
}

export function consumePendingOpenAdminSidebar() {
  if (typeof window === "undefined") return false;
  try {
    const pending = sessionStorage.getItem(PENDING_OPEN_ADMIN_SIDEBAR_KEY) === "1";
    if (pending) sessionStorage.removeItem(PENDING_OPEN_ADMIN_SIDEBAR_KEY);
    return pending;
  } catch {
    return false;
  }
}
/** Dismiss dialogs/sheets opened while the tour spotlight was clickable, before the next step. */
export const CLOSE_TOUR_TRANSIENT_UI_EVENT = "smarttt:close-tour-transient-ui";
export const PINGFLO_TOUR_ACTIVE_EVENT = "smarttt:pingflo-tour-active";
export const PINGFLO_TOUR_CLEARED_EVENT = "smarttt:pingflo-tour-cleared";

export function startPingfloTour({
  playbookId = null,
  mode = "show",
  replay = false,
  role = null,
  startIndex = 0,
  startStepId = null,
} = {}) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(START_UI_GUIDE_EVENT, {
      detail: { playbookId, mode, replay, role, startIndex, startStepId },
    })
  );
}

export function closePingfloCompanion() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(CLOSE_AI_COACH_EVENT));
}

export function emitUiTourSettled({ role, skipped = false, completed = false } = {}) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(UI_TOUR_SETTLED_EVENT, {
      detail: { role, skipped, completed },
    })
  );
}

/** Close overlays that would hide the next tour highlight. */
export function emitCloseTourTransientUi(detail = {}) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(CLOSE_TOUR_TRANSIENT_UI_EVENT, { detail }));
}
